import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import TagManager from 'react-gtm-module';
import backgroundimg from './background.png';
import ToastHandler from 'components/Toast-Handler/toast-handler';
import { tokens } from 'theme/tokens';
import PageHeader from 'global/PageHeader';
import RegistrationForm from './registration-form';
import { registerUser } from 'actions/registration-action';

TagManager.dataLayer({
  dataLayer: {
    event: 'pageview',
    pagePath: '/registration',
    pageTitle: 'registration',
  },
});

const RegistrationPage = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const plan = location && location.search ? location.search.split('=')[1] : 'Regular';
  const newEntity = {
    company: '',
    mcNumber: '',
    dotNumber: '',
    email: '',
    firstName: '',
    lastName: '',
    street: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
    password: '',
    confirmPassword: '',
    accountPlan: plan,
    businessModel: 'OTR',
    policy: false,
    verificationToken: ''
  };  

  const { toast, isProcessing, account } = props;
  const [isRegistrationDialog, setRegistrationDialog] = React.useState(false);
  const [isRegistrationSuccessful, setRegistrationSuccessful] = React.useState(false);
  const [newTenantEntityForm, setNewTenantEntityForm] = useState(newEntity);
  const navigate = useNavigate();
  // Move styles outside component using styled components
  const RootGrid = styled('div')(({ backgroundimg }) => ({
    height: '100vh',
    width: '100vw',
    backgroundImage: `url('${backgroundimg}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));

  const ContainerGrid = styled('div')(({ theme }) => ({
    background: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    width: '50%',
    maxWidth: 900,
    height: 678,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    position: 'absolute',
    right: theme.spacing(12),    
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: '100%',
      maxHeight: 'none',
      boxShadow: theme.shadows[1],
      padding: theme.spacing(0),
      right: theme.spacing(0),
    },
  }));

  const LeftSection = styled('div')(({ theme }) => ({
    flex: 1.5,
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fafafa',
    height: '100%', // Ensure it fills ContainerGrid height
    [theme.breakpoints.down('md')]: {
      minHeight: 180,
      maxHeight: 220,
      flex: 1,
    },
  }));

  const RightSection = styled('div')(({ theme }) => ({
    flex: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2),
    minHeight: 400,
    background: '#fff',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
      minHeight: 400,
      maxHeight: 'none',
      flex: 1,
    },
  }));

  const StyledImage = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover', // Fill the parent and crop if needed
  });

  const StyledAvatar = styled(Avatar)(() => ({
    margin: 'auto',
    backgroundColor: colors.secondary.main,
  }));

  useEffect(() => {
    if (toast && toast.type && toast.action) {
      if (toast.action === 'REGISTRATION') {
        setRegistrationDialog(true);
      }
    }
    if (account && account.status === 'TRIAL') {
      setRegistrationSuccessful(true);
    }
  }, [toast, account]);

  return (
    <RootGrid backgroundimg={backgroundimg}>
      <CssBaseline />
      <ContainerGrid>
        <RightSection>
          <PageHeader
            title={'Sign up.'}
            subTitle={'Register your 30-day free trial. No credit card required.'}
          />
          <br />
          <br />
          <RegistrationForm
            plan={newTenantEntityForm.accountPlan}
            newEntity={newTenantEntityForm}
            toast={toast}
            isProcessing={isProcessing}
            account={account}
            handleRegisterTenant={(newEntity) => props.registerTenant(newEntity)}
          />
        </RightSection>
      </ContainerGrid>
      <Dialog
        open={isRegistrationDialog}
        size={'md'}
      >
        <DialogTitle><Typography variant='h4'>Registration</Typography></DialogTitle>
        <DialogContent>
          <Box>
            {isProcessing ? <CircularProgress style={{ margin: '0px 50%' }} /> : null}
            {toast && toast.message ? <ToastHandler toast={toast} type={toast.type} /> : null}
          </Box>
        </DialogContent>
        {isRegistrationSuccessful ?
          <DialogActions>
            <Button variant='outlined' color={'primary'} onClick={() => navigate('/login', { replace: true })}>Login</Button>
            <Button onClick={() => setRegistrationDialog(false)}>Close</Button>
          </DialogActions> : null
        }
      </Dialog>
    </RootGrid>          
  );
};

const mapStateToProps = state => {
  const { account, isProcessing, toast } = state.registrationReducer;
  return {
    account,
    isProcessing,
    toast
  };
};

const mapDispatchToProps = dispatch => {  
  return {
    registerTenant: user => dispatch(registerUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPage);